import { EventLoader } from './helper-eventloader.js';

/**
 * Layout utility
 * 
 * @version 1.0.0
 */
const LayoutMethods = ( function () {

	/**
	 * -----------------------------------------------------------------------------
	 * Private Layout Helpers
	 * -----------------------------------------------------------------------------
	 */

	const $ = window.jQuery;

	const MILLISECONDS_MULTIPLIER = 1000;
	const ClassName = {
		ACTIVE : 'is-active'
	};

	// shoutout AngusCroll (https://goo.gl/pxwQGp)
	function toType( obj ) {
		return {}.toString.call( obj ).match( /\s([a-z]+)/i )[ 1 ].toLowerCase();
	}

	/**
	 * -----------------------------------------------------------------------------
	 * Public LayoutUtil API
	 * -----------------------------------------------------------------------------
	 */

	const Util = {

		root          : document.documentElement,
		loaders       : [].slice.call( document.querySelectorAll(
			'[data-preloader="main"],' +
			'[data-preloader="sub"]'
		)),
		toolbar       : document.getElementById( 'toolbar' ),
		alert         : document.querySelector( '.tophat' ),
		head          : document.getElementById( 'head' ),
		headAfter     : document.getElementById( 'head-after' ),
		navbar        : document.querySelector( '.c--bts-navbar' ),
		footer        : document.getElementById( 'footer' ),
		footerAfter   : document.getElementById( 'footer-after' ),
		hero          : document.getElementById( 'o-hero' ),
		rows          : [].slice.call( document.querySelectorAll(
			'[data-type="row"]'
		)),
		params : {
			winScrollY    : 0, 
			lastScrollPos : 0,
			running       : false,
			headOffset    : null,
			headData      : null,
			headHeight    : 0,
			navbarHeight  : 0,
			footerHeight  : 0,
			extraOffset   : 0
		},

		destroyElement( element, key = '' )
		{
			$( element )
				.detach()
				.trigger( `${key}` )
				.remove();
		},

		load()
		{
			this.root.style.overflow='hidden';
		},

		register()
		{
			// initialize params
			this.setParams();

			EventLoader.add( () => {

				// reset params
				if ( this.head )
					this.params.headHeight = this.head.offsetHeight;

				if ( this.footer )
					this.params.footerHeight = this.footer.offsetHeight;

				// call methods
				this.setOffset();
				this.setLayout();
				this.setHero();

			});

			EventLoader.throttle( 'scroll', 'optimizedScroll' );
			$( window ).on( 'optimizedScroll', ( e ) => {
				if ( this.running ) { return; }
				this.running = true;

				// run tasks
				if ( this.head )
					this.setHeadScrollPos( this.params.lastScrollPos );

				// complete
				this.running = false;
			});

			// Add bootstrap alert event listener
			$( this.alert ).on( 'closed.bs.alert', ( e ) => {
				this.setOffset();
			});

			// adjust layout
			this.setLayout();
			this.setHero();

			return this;
		},

		setHeader()
		{
			if ( this.params.lastScrollPos <= this.params.headOffset ) {
				this.head.style.top = '';
				this.head.style.position = '';
				$( this.head ).removeClass( ClassName.ACTIVE );
			} else if ( this.params.lastScrollPos > this.params.headOffset ) {
				this.head.style.top = 0 + 'px';
				this.head.style.position = 'fixed';
				$( this.head ).addClass( ClassName.ACTIVE );
			}

			if ( this.params.lastScrollPos > this.params.extraOffset && this.params.headData.data( 'scroll' ) == 0 ) {
				// this.head.style.marginTop = 0 + 'px';
				this.head.style.transform = 'translateY(0px)';
			} else if ( this.params.lastScrollPos > this.params.extraOffset && this.params.headData.data( 'scroll' ) == 1 ) {
				// this.head.style.marginTop = -this.params.navbarHeight + 'px';
				this.head.style.transform = `translateY(${-this.params.navbarHeight}px`;
			} else {
				// this.head.style.marginTop = 0 + 'px';
				this.head.style.transform = 'translateY(0px)';
			}
		},

		setHeadScrollPos( scrollPos )
		{
			this.params.winScrollY = window.pageYOffset;
			// only set navoffset once
			if ( this.params.headOffset == null ) this.setOffset();
			this.params.extraOffset = this.params.headOffset + ( this.params.headHeight * 2 );

			if ( scrollPos < this.params.winScrollY && this.params.headData.data( 'scroll' ) == 0 ) {
				this.params.headData.data( 'scroll', 1 ); // Scrolling down
			} else if ( scrollPos > this.params.winScrollY && this.params.headData.data( 'scroll' ) == 1 ) {
				this.params.headData.data( 'scroll', 0 ); // Scrolling up
			}

			this.params.lastScrollPos = this.params.winScrollY;

			this.setHeader();
		},

		setHero()
		{
			if ( this.hero ) {
				const calcValue = window.innerHeight - this.params.headHeight ;
				this.hero.style.minHeight = calcValue + 'px';
			}
		},

		setLayout()
		{
			if ( this.headAfter )
				this.headAfter.style.height = this.params.headHeight + 'px';

			if ( this.footerAfter)
				this.footerAfter.style.height = this.params.footerHeight + 'px';
		},

		setOffset()
		{
			var offset = 0;
			if ( this.toolbar )
				offset = this.toolbar.offsetTop + this.toolbar.offsetHeight;

			this.params.headOffset = offset;
			this.params.headHeight = this.head ? this.head.offsetHeight : 0;
			this.params.navbarHeight = this.navbar ? this.navbar.offsetHeight : 0;
		},

		setParams()
		{
			this.params.headData      = this.head ? $( this.head ).data( 'scroll', 0 ) : null;
			this.params.headHeight    = this.head ? this.head.offsetHeight : 0;
			this.params.navbarHeight  = this.navbar ? this.navbar.offsetHeight : 0;
			this.params.footerHeight  = this.footer ? this.footer.offsetHeight : 0;
		},

		setProps()
		{
			this.root        = document.documentElement,
			this.toolbar     = document.getElementById( 'toolbar' );
			this.alert       = document.querySelector( '.tophat' );
			this.head        = document.getElementById( 'head' );
			this.headAfter   = document.getElementById( 'head-after' );
			this.navbar      = document.querySelector( '.c--bts-navbar' );
			this.footer      = document.getElementById( 'footer' );
			this.footerAfter = document.getElementById( 'footer-after' );

			return this;
		}
	};

	return Util;

}());

// exports

export { LayoutMethods };